export const validateAge = (age) => {
  const numAge = parseInt(age);
  return age !== "" && !isNaN(numAge) && numAge >= 18 && numAge <= 80;
};

export const validateHeightMetric = (cm) => {
  const numCm = parseInt(cm);
  return cm !== "" && !isNaN(numCm) && numCm >= 100 && numCm <= 245;
};

export const validateHeightImperial = (feet, inches) => {
  const numFeet = parseInt(feet);
  const numInches = parseInt(inches);

  if (feet === "" || inches === "" || isNaN(numFeet) || isNaN(numInches)) {
    return false;
  }

  if (numInches < 0 || numInches > 11) return false;

  const totalInches = numFeet * 12 + numInches;
  return totalInches >= 39 && totalInches <= 96;
};

export const validateWeightMetric = (currentKg, goalKg) => {
  const numCurrent = parseFloat(currentKg);
  const numGoal = parseFloat(goalKg);
  return (
    currentKg !== "" &&
    goalKg !== "" &&
    !isNaN(numCurrent) &&
    !isNaN(numGoal) &&
    numCurrent >= 30 &&
    numCurrent <= 300 &&
    numGoal >= 30 &&
    numGoal <= 300 &&
    numGoal < numCurrent
  );
};

export const validateWeightImperial = (currentLb, goalLb) => {
  const numCurrent = parseFloat(currentLb);
  const numGoal = parseFloat(goalLb);
  return (
    currentLb !== "" &&
    goalLb !== "" &&
    !isNaN(numCurrent) &&
    !isNaN(numGoal) &&
    numCurrent >= 60 &&
    numCurrent <= 661 &&
    numGoal >= 60 &&
    numGoal <= 661 &&
    numGoal < numCurrent
  );
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return email !== "" && emailRegex.test(email);
};

export const getAgeError = () => "Please enter a valid age between 18 and 80";

export const getHeightError = () => {
  return "Please enter a valid height between 100 and 245 cm (or 3 ft 3 in and 8 feet)";
};

export const getWeightError = (current, goal, unit = "metric") => {
  const numCurrent = parseFloat(current);
  const numGoal = parseFloat(goal);

  const isImperial = unit === "imperial";
  const min = isImperial ? 60 : 30;
  const max = isImperial ? 661 : 300;

  const isRangeError =
    current === "" ||
    goal === "" ||
    isNaN(numCurrent) ||
    isNaN(numGoal) ||
    numCurrent < min ||
    numCurrent > max ||
    numGoal < min ||
    numGoal > max;

  if (isRangeError) {
    return "Please enter a valid weight between 30 and 300 kg (or 66 and 661 lbs)";
  }

  if (numGoal >= numCurrent) {
    return "Your goal weight should be less than your current weight";
  }

  // Fallback default
  return "Please enter a valid weight";
};

export const getEmailError = () => "Please enter a valid email address";
